export default __webpack_public_path__ + "static/media/Shehzadi-ka-Roza.d02d3b78.jpg";